export class ProductMobileSlider {
	constructor(e, t) {
		;((this.slider = e),
			this.slider.addEventListener('scroll', e => {
				var t = document.querySelectorAll('.dot.visible')
				;(t.forEach(e => {
					e.classList.remove('active')
				}),
					t[Math.round(this.slider.scrollLeft / this.slider.clientWidth)].classList.add('active'))
			}),
			document.querySelectorAll('.dot').forEach(e => {
				e.addEventListener('click', t => {
					this.slideTo(e)
				})
			}))
	}
	slideTo(e) {
		document.querySelectorAll('.dot.visible').forEach((t, l) => {
			t == e && this.slider.scrollTo({ left: l * this.slider.clientWidth })
		})
	}
}
